/**
 * Custom procedure code system URL
 * Practice-specific custom codes are stored in CodeSystem resources scoped to the practice
 */
export const CUSTOM_PROCEDURE_CODE_SYSTEM =
  "http://quiltedhealth.com/fhir/CodeSystem/custom-procedure-codes";

/**
 * Base URL for practice-specific custom code ValueSets
 * Format: {CUSTOM_PROCEDURE_VALUE_SET_BASE_URL}/{practiceId}
 */
export const CUSTOM_PROCEDURE_VALUE_SET_BASE_URL =
  "http://quiltedhealth.com/fhir/ValueSet/custom-procedure-codes";

export { CHARGE_ITEM_DEFINITION_BASE_URL } from "@/fhir/charge-item-definition";

/** What a custom code may contain; the drawer's placeholder and the validation error both use it. */
export const CUSTOM_CODE_FORMAT_HINT =
  "Letters and/or numbers, with one optional dash (e.g. TUB, 1562-23)";
